import { render, staticRenderFns } from "./footer-checkout.vue?vue&type=template&id=a2e426e6&scoped=true"
import script from "./footer-checkout.vue?vue&type=script&lang=js"
export * from "./footer-checkout.vue?vue&type=script&lang=js"
import style0 from "./footer-checkout.vue?vue&type=style&index=0&id=a2e426e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2e426e6",
  null
  
)

export default component.exports